/**
 * Action to fetch the base quote config from products service
 *
 */
export class LoadQuoteConfig {
  public static readonly type = '[QuoteConfig] Fetch Quote config';
  constructor(public brand: string) {}
}
